/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import"../../core/units.js";import"./gx/operatorGeodeticArea.js";import"./support/geodeticCurveType.js";export{e as execute,i as isLoaded,l as load,s as supportsCurves}from"../../chunks/geodeticAreaOperator.js";
